import { deepEquals } from '@nike/ciclp-utils';

// Remove duplicates using deep equality comparison
export const uniqueByValue = arr => {
  const seen = [];
  return arr.filter(item => {
    const isDuplicate = seen.some(seenItem => deepEquals(seenItem, item));
    if (isDuplicate) return false;
    seen.push(item);
    return true;
  });
};
